// context/GameStateContext.tsx

import React from 'react';
import { GameState, SimplifiedChampion } from '../../gameTypes';

interface GameStateContextValue {
  gameState: GameState | null;
  championIdToTeamMap: { [championId: string]: 'blue' | 'red' };
  getChampionById: (id: string) => SimplifiedChampion | null;
}

const GameStateContext = React.createContext<GameStateContextValue>({
  gameState: null,
  championIdToTeamMap: {},
  getChampionById: () => null,
});

export default GameStateContext;
